import React, { useContext, useEffect, useState } from 'react';
import get from 'lodash/get';
import Cookies from 'js-cookie';
import toast from 'toasted-notes';
import { Buffer } from 'buffer';
import { useDispatch } from 'react-redux';

import LoginIntro from './LoginIntro';
import { getEventDetails, getImageSource, getLocalAppStateAsync } from '../../../services/api/db';
import Auth from '../../../services/api/auth';
import {
    getFullProfile,
    getLatestPrivacyPolicy,
    getUserSettings,
    isUserAttendingByEmail,
    updateFullProfile,
    updateUserPrivacyPolicy,
    updateUserSettings,
} from '../../../services/api/eureka';
import { aboutLinks, DIALOG_MESSAGE, validateEmail, validatePassword } from '../constants/strings';
import { default as Store, getString } from '../../../services/api/store';
import Password from './Password';
import ForgotPassword from './ForgotPassword';
import eventBus from '../../../utils/eventBus';
import { withRouter } from 'react-router-dom';
import { Container } from '../style/signIn';
import { useTheme } from '../../../components/Theme/ThemeContext';
import AuthUserContext from '../../../components/Session/AuthUserContext';
import ResetPasswordSuccess from './ResetPasswordSuccess';
import UnauthorizedAttendeeContent from './UnauthorizedAttendeeContent';
import UnauthorizedGroupContent from './UnauthorizedGroupContent';
import Register from './Regiester';
import PrivacyPolicy from './PrivacyPolicy';
import LoginVerificationPage from './LoginVerification';
import AddProfileImage from './AddProfileImage';
import { useGlobalState } from '../../../utils/container';
import ProfileImageSuccessfullyAdded from './ProfileImageSuccessfullyAdded';
import Welcome from './Welcome';
import SettingsModal from '../../../scenes/User/containers/SettingsModal';
import * as palette from '../../../components/General/Variables';
import OAuthPasswordPage from './OAuthPasswordPage';
import ProfileModal from '../../User/containers/profile/ProfileModal';
import { WithTimezone } from '../../Timezone/context';
import AttendeesSettings from './AttendeesSettings';
import ChatAndMeetingsSettings from './ChatAndMeeetingsSettings';
import {
    AchievementType,
    useAchievementActions,
} from '../../Achievements/hooks/useAchievementActions';
import { loadIsGamificationEnabled } from '../../Achievements/actions';
import { AWS_IMAGES_ENDPOINT, S3_ENDPOINT_IMAGES } from '../../../config';
import { Button, DialogContainer, Toolbar } from 'react-md';
import styled from 'styled-components';

export const Dialog = styled(DialogContainer)`
    .md-background--card {
        background: transparent;
        box-shadow: unset;
    }

    .md-toolbar {
        display: none;
    }

    .md-dialog-content--padded {
        padding: 0;
    }

    .md-dialog--centered {
        max-width: unset !important;
        max-height: unset !important;
    }
`;

export const Background = React.memo(({ image }) => (
    <Container>
        <Image image={image} />
    </Container>
));
Background.displayName = 'LoginBackground';

const Image = React.memo(function Image({ image }) {
    if (!image) {
        return null;
    }

    let displayImage = image;
    if (AWS_IMAGES_ENDPOINT && S3_ENDPOINT_IMAGES && image) {
        displayImage = image.replace(S3_ENDPOINT_IMAGES, AWS_IMAGES_ENDPOINT);
    }

    return (
        <div
            src={displayImage}
            style={{
                width: '100vw',
                height: '100vh',
                background: `#fff url(${displayImage}) no-repeat center/cover fixed`,
                position: 'relative',
            }}
        />
    );
});

const SignIn = props => {
    const { history, location, isSociety } = props;
    const stateCtx = useGlobalState();
    const { theme } = useTheme();
    const { socket } = stateCtx;
    const [currentPage, setCurrentPage] = useState(props.signInCurrentPage || 'intro');
    const [auth, setAuth] = useState(null);
    const [appState, setAppState] = useState(null);
    const [isAttendeeRestriction, setIsAttendeeRestriction] = useState(false);
    const [mailResent, setMailResent] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [profileVisible, setProfileVisible] = useState(false);
    const [eventDetails, setEventDetails] = useState({});
    const currentPathIsSignIn = props.location.pathname.toLowerCase().includes('/sign-in');

    const [email, setEmail] = useState({
        value: '',
        isValidEmail: false,
    });
    const [forgotEmail, setForgotEmail] = useState({
        value: '',
        isValidEmail: false,
    });
    const [firstName, setFirstName] = useState({
        value: '',
        isValidFn: false,
    });
    const [lastName, setLastName] = useState({
        value: '',
        isValiLn: false,
    });
    const [company, setCompany] = useState({
        value: '',
        isValidCompany: false,
    });
    const [jobTitle, setJobTitle] = useState({
        value: '',
        isValidJobTitle: false,
    });
    const [privacyAgreed, setPrivacyAgreed] = useState(true);
    const [password, setPassword] = useState(null);
    const [error, setError] = useState(null);
    const [passwordRegister, setPasswordRegister] = useState({
        value: '',
        isValidPass: false,
    });
    const [signInImage, setSignInImage] = useState(null);
    const [privacyPolicy, setPrivacyPolicy] = useState({});
    const signInBackground = Store.argument && Store.argument.signInBackground;
    const networkingEnabled = Store.argument && Store.argument.app.enableChat;
    const dispatch = useDispatch();
    const { trackAchievement } = useAchievementActions();
    const { authUser } = useContext(AuthUserContext);

    const TEXT_SUBTITLE = getString('loginMainText') || DIALOG_MESSAGE;

    useEffect(() => {
        (async () => {
            try {
                const userOnboardingInfoToken = Cookies.get('userOnboardingInfo');
                const userOnboardingInfo = JSON.parse(
                    Buffer.from(userOnboardingInfoToken, 'base64').toString('binary'),
                );
                if (userOnboardingInfo && userOnboardingInfo.email) {
                    updateFirstName(decodeURIComponent(userOnboardingInfo.firstName));
                    updateLastName(decodeURIComponent(userOnboardingInfo.lastName));
                    changeEmail(userOnboardingInfo.email);
                    Cookies.remove('userOnboardingInfo');
                }
            } catch (e) {
                // console.log('wrong token');
            }

            const localAppState = await getLocalAppStateAsync();
            setAppState(localAppState);
            if (!isSociety) {
                const eventDetails = await getEventDetails(
                    localAppState.eventId,
                    localAppState.configuratorUrl,
                );
                setEventDetails(eventDetails);
            } else {
                setEventDetails({
                    banner: localAppState.societyLogoUrl,
                    name: localAppState.appName,
                    subtitle: TEXT_SUBTITLE,
                    society: true,
                });
            }

            if (isSociety && localAppState && localAppState.signInBackgroundImageUrl) {
                setSignInImage(localAppState.signInBackgroundImageUrl);
            } else if (signInBackground) {
                getImageSource(signInBackground, (err, img) => {
                    setSignInImage(img);
                });
            }

            setIsAttendeeRestriction(localAppState.attendingOnly);

            let latestPolicy = await getLatestPrivacyPolicy();
            if (!latestPolicy) {
                latestPolicy = {
                    url: 'https://www.iubenda.com/privacy-policy/51127541',
                    version: 1,
                };
            }
            setPrivacyPolicy(latestPolicy);
            updateAuthSettings();
            Auth.setPolicyFlow(checkPolicy, latestPolicy);
        })();
    }, [isSociety]);

    const handleGoHome = () => {
        const previousPath = get(location, 'state.prevPath', null);
        if (previousPath && !previousPath.includes('/sign-in')) {
            return history.push(previousPath);
        } else if (location.pathname.includes('/sign-in')) {
            return history.push(location.pathname.replace('/sign-in', ''));
        } else {
            history.goBack();
        }
    };

    const goHome = () => {
        if (props.onHideDialog) {
            props.onHideDialog();
            if (props.location.pathname.includes('/exhibitorbooth')) {
                handleGoHome();
            }
            return;
        }

        handleGoHome();
    };

    useEffect(() => {
        if (authUser && currentPage === 'intro') {
            return goHome();
        }
    }, [authUser]);

    const updateAuthSettings = () => {
        Auth.getAuthSettings((err, config) => {
            if (config && config.externalEurekaLogin && config.externalLoginOptions) {
                setAuth({
                    ...config.externalLoginOptions,
                    organization: config.externalEurekaLogin,
                    authorizeUrl: config.authorizeUrl,
                    buttonTitle: config.signInButtonTitle,
                    grantTypePasswordState: config.grantTypePasswordState,
                    addEmail: config.addEmail,
                    options: config.options,
                });
            }
        });
    };

    const resetState = () => {
        const initialEmailObject = {
            value: '',
            isValidEmail: false,
        };
        setForgotEmail(initialEmailObject);
        setEmail(initialEmailObject);
        setPassword(null);
        setError(null);
        setCurrentPage('intro');
    };

    const goTo = page => {
        if (isSociety && page === 'attendeesSettings') {
            return goHome();
        }
        setCurrentPage(page);
    };

    const signin = () => {
        Auth.doSignInWithEmailAndPassword(email.value, password, async (error, isValid) => {
            if (error) {
                setError(error);
            } else if (isValid) {
                if (isSociety) {
                    return goHome();
                }

                if (props.timezone) {
                    props.timezone.setTimezoneFromEurekaSettings();
                }
                setTimeout(() => {
                    eventBus.emit('updateMyProgrammeCount');
                    eventBus.emit('updateNotesCount');
                    eventBus.emit('updateMyFavoritesCount');
                    eventBus.emit('updateConversationsCount');
                }, 1000);
                const cookies = Cookies.get(`event-${appState.eventId}-visited`);
                if (cookies) {
                    const response = await getUserSettings(appState.eventId);
                    if (response && response.available === false) {
                        goTo('chatAndMeetingsSettings');
                    } else {
                        if (currentPathIsSignIn && !isSociety) {
                            goHome();
                        } else {
                            window.location.reload();
                        }
                    }
                } else {
                    Cookies.set(`event-${appState.eventId}-visited`, 'visited');
                    goTo('attendeesSettings');
                }
            } else {
                goTo('verification');
            }
        });
    };

    const goNextFromAttendeesSettings = async profileVisible => {
        setProfileVisible(profileVisible);
        const cookies = Cookies.get(`event-${appState.eventId}-visited`);
        if (cookies) {
            const response = await getUserSettings(appState.eventId);
            if (response && response.available === false) {
                goTo('chatAndMeetingsSettings');
            } else {
                if (currentPathIsSignIn && !isSociety) {
                    goHome();
                } else {
                    window.location.reload();
                }
            }
        } else {
            goTo('chatAndMeetingsSettings');
        }
    };

    const close = () => {
        goHome();
    };

    const forgotPassword = () => {
        goTo('forgotPassword');
    };

    const resetPassword = () => {
        Auth.resetPassword(forgotEmail.value, error => {
            if (error) {
                setError(error);
            } else {
                goTo('resetPasswordSuccess');
            }
        });
    };

    const resetFlow = () => {
        resetState();
        updateAuthSettings();
    };

    const onKeyDown = (e, fn) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            fn();
        }
    };

    const changeEmail = mail => {
        const isValidEmail = validateEmail(mail);
        setEmail({
            value: mail,
            isValidEmail,
        });
        setError(null);
    };

    const updateForgotEmail = mail => {
        const isValidEmail = validateEmail(mail);
        setForgotEmail({
            value: mail,
            isValidEmail,
        });
        setError(null);
    };

    const updateFirstName = name => {
        setFirstName({
            value: name,
            isValidFn: name.length > 0,
        });
    };

    const updatePassword = pass => {
        setPasswordRegister({
            value: pass,
            isValidPass: validatePassword(pass),
        });
    };

    const updateLastName = name => {
        setLastName({
            value: name,
            isValidLn: name.length > 0,
        });
    };

    const updateCompany = name => {
        setCompany({
            value: name,
            isValidCompany: name.length > 0,
        });
    };

    const updateJobTitle = name => {
        setJobTitle({
            value: name,
            isValidJobTitle: name.length > 0,
        });
    };

    const updatePrivacySettings = value => {
        setPrivacyAgreed(value);
    };

    const authorize = isAttendeeRestriction => {
        if (auth.grantTypePasswordState) {
            goTo('oAuthPassword', isAttendeeRestriction);
        } else {
            const msg = Auth.authTab(
                auth.options,
                palette.DIALOG_WIDTH,
                palette.DIALOG_HEIGHT,
                isAttendeeRestriction,
            );
            msg.then(success => {
                if (success) {
                    if (success.err && success.err === 'notAttendingError') {
                        return goTo('unauthorizedAttendee');
                    }
                    close();
                }
            }).catch(() => {
                toast.notify('There was an error at log in', {
                    position: 'bottom-left',
                });
            });
        }
    };

    const checkPolicy = (user, policy, token, next) => {
        if (user && policy && policy.version && policy.version > user.acceptedPolicyVersion) {
            setPrivacyPolicy({
                ...policy,
                successAction: next,
                token,
            });
            goTo('privacyPolicy');
        } else {
            next();
        }
    };

    const updatePolicy = async () => {
        if (!privacyPolicy.version) {
            return;
        }
        try {
            await updateUserPrivacyPolicy(privacyPolicy.version, privacyPolicy.token);
            if (privacyPolicy.successAction && typeof privacyPolicy.successAction === 'function') {
                privacyPolicy.successAction();
            }
        } catch {
            console.log('privacyPolicyUpadateError');
        }
    };

    const checkEmail = () => {
        Auth.checkIfEmailExists(email.value, async (error, result) => {
            if (error) {
                setError(error);
            } else {
                if (!isSociety) {
                    const checkforgroup = appState.groupCanSignOnly || appState.groupCanAccessOnly;
                    let restricted = false;
                    if (isAttendeeRestriction || checkforgroup) {
                        restricted = true;
                    }
                    let isAttending = await isUserAttendingByEmail(appState.eventId, email.value);
                    if (checkforgroup && checkforgroup > 0) {
                        isAttending = false;
                        const { userGroups } = result;
                        if (userGroups && userGroups.length) {
                            isAttending = userGroups.some(item => item.id === checkforgroup);
                        }
                    }

                    if (restricted && !isAttending) {
                        return goTo('unauthorizedAttendee');
                    }
                }

                if (result.registered && result.email.toLowerCase() === email.value.toLowerCase()) {
                    goTo('password');
                } else {
                    goTo('register');
                }
            }
        });
    };

    const register = () => {
        if (
            privacyAgreed &&
            firstName.isValidFn &&
            lastName.isValidLn &&
            company.isValidCompany &&
            jobTitle.isValidJobTitle &&
            passwordRegister.isValidPass
        ) {
            Auth.register(
                email.value,
                firstName.value,
                lastName.value,
                passwordRegister.value,
                error => {
                    if (error) {
                        setError(error);
                    } else {
                        goTo('verification');
                    }
                },
            );
        }
    };

    const resendEmail = () => {
        Auth.resendConfirmation(error => {
            if (error) {
                setError(error);
            } else {
                setMailResent(true);
            }
        });
    };

    const confirmEmail = () => {
        Auth.isAccountValidated(error => {
            if (error) {
                setError(error);
            } else {
                if (!isSociety) {
                    Cookies.set(`event-${appState.eventId}-visited`, 'visited');
                }

                goTo('profileImage');
            }
        });
    };

    const saveProfileInfo = async imageUrl => {
        const userData = await getFullProfile();
        const data = {
            ...userData,
            imageUrl: imageUrl || profileImage,
            companyName: company.value,
            jobTitle: jobTitle.value,
            firstName: firstName.value,
            lastName: lastName,
        };
        await updateFullProfile(data);
        Auth.changeAuthUserData(data);

        if (socket) {
            socket.emit('profileChanged', { id: userData.id });
        }
    };

    const oAuthPasswordAuthenticate = (username, password) => {
        const data = {
            username,
            password,
            state: auth.grantTypePasswordState,
            organization: auth.organization,
        };
        Auth.oAuthPasswordAuthenticate(
            data,
            error => {
                if (error && error === 'notAttendingError') {
                    goTo('unauthorizedAttendee');
                } else if (error) {
                    setError(error);
                } else {
                    resetFlow();
                    close();
                }
            },
            isAttendeeRestriction,
        );
    };

    const onSaveProfileSettings = async chatAvailable => {
        const userData = await getFullProfile();
        const settings = {
            visible: profileVisible,
            available: chatAvailable,
            eventId: appState.eventId,
            eventTitle: appState.eventName,
        };

        await updateUserSettings(settings);

        if (socket) {
            socket.emit('privacySettingsUpdated', {
                eventId: appState.eventId,
                userId: userData.id,
            });
        }
        const cookies = Cookies.get(`event-${appState.eventId}-visited`);

        // track achievement
        const isGamificationEnabled = await dispatch(loadIsGamificationEnabled());
        if (isGamificationEnabled) {
            trackAchievement(AchievementType.COMPLETE_PROFILE, undefined, true);
        }

        if (cookies) {
            if (currentPathIsSignIn && !isSociety) {
                goHome();
            } else {
                window.location.reload();
            }
        } else {
            goTo('welcome');
        }
    };

    const terms = appState?.termsUrl;

    useEffect(() => {
        if (!networkingEnabled && currentPage === 'attendeesSettings') {
            goNextFromAttendeesSettings(false);
        }
        if (!networkingEnabled && currentPage === 'chatAndMeetingsSettings') {
            onSaveProfileSettings(false);
        }
    }, [networkingEnabled, currentPage]);

    const buildContent = theme => {
        switch (currentPage) {
            case 'intro':
                return (
                    <LoginIntro
                        goTo={goTo}
                        eventDetails={eventDetails}
                        currentPage={currentPage}
                        attendingOnly={appState && appState.attendingOnly}
                        email={email.value}
                        updateEmail={mail => changeEmail(mail)}
                        onKeyDown={onKeyDown}
                        error={error}
                        isValid={email.isValidEmail}
                        checkEmail={checkEmail}
                        appName={
                            isSociety
                                ? appState && appState.appName
                                : appState && appState.eventName
                        }
                        isSociety={isSociety}
                        theme={theme}
                        eurekaOnly={appState && appState.eurekaOnly}
                        auth={auth}
                        authorize={authorize}
                        onClose={close}
                        isModal={props.visible}
                        groupCanSignOnly={appState && appState.groupCanSignOnly}
                        groupCanAccessOnly={appState && appState.groupCanAccessOnly}
                    />
                );
            case 'email':
                return (
                    <LoginIntro
                        goTo={goTo}
                        appState={appState}
                        currentPage={currentPage}
                        attendingOnly={appState && appState.attendingOnly}
                        email={email.value}
                        updateEmail={mail => changeEmail(mail)}
                        onKeyDown={onKeyDown}
                        error={error}
                        isValid={email.isValidEmail}
                        checkEmail={checkEmail}
                        appName={appState && appState.eventName}
                        theme={theme}
                        eurekaOnly={appState && appState.eurekaOnly}
                        auth={auth}
                        authorize={authorize}
                        onClose={close}
                        isModal={props.visible}
                    />
                );
            case 'password':
                return (
                    <Password
                        goTo={goTo}
                        email={email.value}
                        updatePassword={pass => setPassword(pass)}
                        onKeyDown={onKeyDown}
                        error={error}
                        signin={signin}
                        isValid={password && password.length > 0}
                        checkEmail={checkEmail}
                        forgotPassword={forgotPassword}
                        theme={theme}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                        terms={terms}
                        privacyPolicy={privacyPolicy?.url}
                    />
                );
            case 'privacyPolicy':
                return (
                    <PrivacyPolicy
                        goToSignIn={resetFlow}
                        privacyPolicy={privacyPolicy}
                        updatePolicy={updatePolicy}
                        theme={theme}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );
            case 'forgotPassword':
                return (
                    <ForgotPassword
                        email={forgotEmail.value}
                        updateEmail={mail => updateForgotEmail(mail)}
                        isValid={forgotEmail.isValidEmail}
                        onKeyDown={onKeyDown}
                        resetPassword={resetPassword}
                        error={error}
                        theme={theme}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );
            case 'resetPasswordSuccess':
                return (
                    <ResetPasswordSuccess
                        theme={theme}
                        goToSignIn={resetFlow}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'unauthorizedAttendee':
                return (
                    <UnauthorizedAttendeeContent
                        theme={theme}
                        onHide={resetFlow}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        groupCanSignOnly={appState && appState.groupCanSignOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'register':
                return (
                    <Register
                        password={passwordRegister.value}
                        privacyPolicy={privacyPolicy?.url}
                        updatePassword={updatePassword}
                        firstName={firstName.value}
                        updateFirstName={updateFirstName}
                        register={register}
                        error={error}
                        lastName={lastName.value}
                        updateLastName={updateLastName}
                        theme={theme}
                        company={company.value}
                        updateCompany={updateCompany}
                        jobTitle={jobTitle.value}
                        updateJobTitle={updateJobTitle}
                        isValid={
                            privacyAgreed &&
                            firstName.isValidFn &&
                            lastName.isValiLn &&
                            company.isValidCompany &&
                            jobTitle.isValidJobTitle &&
                            passwordRegister.isValidPass
                        }
                        updatePrivacySettings={updatePrivacySettings}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                        terms={terms}
                    />
                );

            case 'verification':
                return (
                    <LoginVerificationPage
                        theme={theme}
                        goTo={goTo}
                        email={email.value}
                        confirmEmail={confirmEmail}
                        resendEmail={resendEmail}
                        mailResent={mailResent}
                        onKeyDown={onKeyDown}
                        error={error}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'profileImage':
                return (
                    <AddProfileImage
                        theme={theme}
                        goTo={goTo}
                        setProfileImage={img => setProfileImage(img)}
                        saveProfileInfo={saveProfileInfo}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'imageAdded':
                return (
                    <ProfileImageSuccessfullyAdded
                        theme={theme}
                        goTo={goTo}
                        profileImage={profileImage}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'attendeesSettings':
                if (!networkingEnabled) {
                    return null;
                }
                return (
                    <AttendeesSettings
                        theme={theme}
                        goNextFromAttendeesSettings={goNextFromAttendeesSettings}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'chatAndMeetingsSettings':
                if (!networkingEnabled) {
                    return null;
                }
                return (
                    <ChatAndMeetingsSettings
                        theme={theme}
                        onSaveProfileSettings={onSaveProfileSettings}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'welcome':
                return (
                    <Welcome
                        theme={theme}
                        goTo={goTo}
                        profileImage={profileImage}
                        firstName={firstName.value}
                        lastName={lastName.value}
                        company={company.value}
                        jobTitle={jobTitle.value}
                        goHome={goHome}
                        handleProfileModal={handleProfileModal}
                        attendingOnly={appState && appState.attendingOnly}
                        eurekaOnly={appState && appState.eurekaOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            case 'oAuthPassword':
                return (
                    <OAuthPasswordPage
                        auth={auth}
                        theme={theme}
                        authenticate={oAuthPasswordAuthenticate}
                        onKeyDown={onKeyDown}
                        error={error}
                        isModal={props.visible}
                    />
                );

            case 'unauthorizedGroup':
                return (
                    <UnauthorizedGroupContent
                        theme={theme}
                        onHide={resetFlow}
                        groupCanSignOnly={appState && appState.groupCanSignOnly}
                        onClose={close}
                        isModal={props.visible}
                    />
                );

            default:
                return null;
        }
    };

    const handleSettingsModal = () => {
        setShowSettingsModal(!showSettingsModal);
    };

    const handleCloseSettingsModal = () => {
        setShowSettingsModal(false);
        goHome();
    };

    const closeProfileModal = () => {
        setShowProfileModal(false);
        goHome();
    };

    const handleProfileModal = () => {
        setShowProfileModal(true);
    };

    const signInModalVisible = props.visible;
    // if ((appState?.attendingOnly || appState?.eurekaOnly) && !currentPathIsSignIn) {
    //     props.history.push('/sign-in');
    // }
    if (theme.kiosk) {
        return null;
    }

    return (
        <React.Fragment>
            <Dialog
                id="speed-boost"
                visible={true}
                modal
                onHide={goHome}
                width={signInModalVisible && !currentPathIsSignIn ? palette.DIALOG_WIDTH : '100vw'}
                height={
                    signInModalVisible && !currentPathIsSignIn ? palette.DIALOG_HEIGHT : '100vh'
                }
                aria-describedby="speed-boost-description"
                style={{
                    zIndex: '100 !important',
                }}
            >
                <Toolbar
                    id="sign-in-toolbar"
                    title={''}
                    titleId="simple-full-page-dialog-title"
                    actions={
                        <Button
                            style={{
                                color: palette.COLOR_TEXT,
                                marginRight: -25,
                                marginTop: -10,
                            }}
                            icon
                        ></Button>
                    }
                />
                {signInModalVisible && !currentPathIsSignIn && !isSociety ? (
                    <>{buildContent(theme)}</>
                ) : (
                    <>
                        <Background image={signInImage} />
                        {buildContent(theme)}
                    </>
                )}
            </Dialog>
            {showProfileModal && (
                <ProfileModal
                    afterSignUp
                    onClose={closeProfileModal}
                    handleSettingsModal={handleSettingsModal}
                />
            )}
            {showSettingsModal && <SettingsModal afterSignUp onClose={handleCloseSettingsModal} />}
        </React.Fragment>
    );
};

export default withRouter(WithTimezone(SignIn));
